export default {
  methods: {
    /**
     * Initialize the eCommerce Plugin.
     */
    initializePlugin (GenCert, element, options) {
      if (GenCert) {
        return GenCert.init(element, options)
      }
    }
  }
}
